import LeaderboardStats from './LeaderboardStats';
import React, { useState, useEffect } from 'react'
import { cardStyle } from './styles'
import { getTodayString, getApiUrl, getHomeUrl, requestGame } from './gameLogic'
import Leaderboard from './Leaderboard'
import LegacyLeaderboard from './legacy/Leaderboard'
import { LeaderboardFrame, DateSelector, formatLeaderboardDate, fetchGameStatuses } from '@precisionpros/game-ui'
import { eventProGame } from './EventProBrand'

const getOtherGameFrontends = () => {
  const apiUrl = getApiUrl()
  const isLocalDev = apiUrl.includes("localhost") || apiUrl.includes("127.0.0.1")
  if (isLocalDev) {
    return {
      wordpro: "http://localhost:3005",
      connectpro: "http://localhost:3001",
      buildpro: "http://localhost:3003",
      wordprofinder: "http://localhost:3004",
      seashroud: "http://localhost:3006",
      mathpro: "http://localhost:3008",
      sevenapart: "http://localhost:3007",
    }
  }
  return {
    wordpro: "https://wordpro.precisionpros.com",
    connectpro: "https://connectpro.precisionpros.com",
    buildpro: "https://buildpro.precisionpros.com",
    wordprofinder: "https://wordprofinder.precisionpros.com",
    seashroud: "https://seashroud.precisionpros.com",
    mathpro: "https://mathpro.precisionpros.com",
    sevenapart: "https://sevenapart.precisionpros.com",
  }
}


export default function LeaderboardPage({ playerName, timedStartDate = '' }) {
  const currentPlayer = playerName || localStorage.getItem('playerName') || ''
  const [date, setDate] = useState(getTodayString)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [statuses, setStatuses] = useState({})
  const [hasPlayedToday, setHasPlayedToday] = useState(false)
  const shouldHideToday = date === getTodayString() && statuses.eventpro !== true && !hasPlayedToday
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let cancelled = false
    fetchGameStatuses().then(data => { if (!cancelled) setStatuses(data) }).catch(() => {})
    return () => { cancelled = true }
  }, [])
  useEffect(() => {
    let cancelled = false
    requestGame('has-played-today/', currentPlayer).then(data => {
      if (!cancelled) setHasPlayedToday(data.has_played === true || data.has_played_today === true)
    }).catch(() => {})
    return () => { cancelled = true }
  }, [currentPlayer])
  useEffect(() => {
    let cancelled = false
    setLoading(true); setError('')
    if (shouldHideToday) {
      setRows([]); setLoading(false)
      return () => { cancelled = true }
    }
    requestGame(`leaderboard/?date=${date}`, currentPlayer).then(data => {
      if (!cancelled) setRows(data)
    }).catch(err => { if (!cancelled) setError(err.message) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [date, currentPlayer, retry, shouldHideToday])
  const legacy = !!timedStartDate && date < timedStartDate
  const Results = legacy ? LegacyLeaderboard : Leaderboard
  const changeDay = delta => {
    const day = new Date(`${date}T12:00:00`)
    day.setDate(day.getDate() + delta)
    const next = `${day.getFullYear()}-${String(day.getMonth()+1).padStart(2,'0')}-${String(day.getDate()).padStart(2,'0')}`
    if (next <= getTodayString()) setDate(next)
  }
  const frontends = { ...getOtherGameFrontends(), eventpro: window.location.origin }
  const games = [['wordpro','W','#4CAF50'],['connectpro','C','#2563eb'],['eventpro','E','#ea580c'],['buildpro','B','#0f766e'],['wordprofinder','WF','#4CAF50'],['seashroud','S','#287f89'],['sevenapart','7','#644a83'],['mathpro','M','#996128']]
  const links = games.map(([key,letter,color]) => ({ key,letter,color,played:!!statuses[key],href:`${frontends[key]}${statuses[key] ? '/leaderboard' : '/'}${currentPlayer ? `?player_name=${encodeURIComponent(currentPlayer)}` : ''}` }))
  return <LeaderboardFrame game={eventProGame} currentGameKey="eventpro" title="Leaderboard" showPrePlayBanner={shouldHideToday} links={links} homeHref={getHomeUrl()} playHref="/" howToPlayHref="/how-to-play" dateSelector={<DateSelector dateLabel={formatLeaderboardDate(date)} onPrevious={() => changeDay(-1)} onNext={() => changeDay(1)} />}>
    <h2 style={{ fontSize: '1.15rem' }}>Today’s Results</h2>
    {!shouldHideToday && <section style={cardStyle}>
      <p style={{ color: '#666', lineHeight: 1.6, fontSize: '.9rem' }}>{legacy ? 'Historical wager round. Equal payouts share a place; these players were not timed.' : 'Most correct placements first, then fastest time. Matching scores and times share a place.'}</p>
      {loading ? <p role="status">Loading results…</p> : error ? <div role="alert">{error} <button onClick={() => setRetry(v => v+1)}>Try again</button></div> : <Results data={rows} playerName={currentPlayer} />}
      <p style={{ fontSize: '.8rem', color: '#888', marginBottom: 0 }}>{legacy ? 'Original wager results are preserved.' : 'Only completed timed rounds appear here.'}</p>
    </section>}
    <LeaderboardStats endpoint={`${getApiUrl()}/eventpro/leaderboard-records/`} date={date} />
  </LeaderboardFrame>
}
